// extracted by mini-css-extract-plugin
export var aboveInput = "_m0-0";
export var actionButton = "_m0-5";
export var actionButtonContainer = "_m0-1";
export var actionIcon = "_m0-6";
export var aiInfoContainer = "_m0-2";
export var attachmentWrapper = "_m0-7";
export var bold = "_m0-3";
export var checkIcon = "_m0-8";
export var clickingRecipientBar = "_m0-11";
export var commentThreadSwitch = "_m0-a";
export var draftImage = "_m0-b";
export var draftImageContainer = "_m0-c";
export var draftImages = "_m0-e";
export var editButton = "_m0-g";
export var editor = "_m0-f";
export var editorContainer = "_m0-y";
export var editorErrorTooltipWrapper = "_m0-9";
export var headerDivider = "_m0-h";
export var icon = "_m0-i";
export var info = "_m0-j";
export var internal = "_m0-n";
export var internalDivider = "_m0-k";
export var internalMessage = "_m0-l";
export var messageInputCard = "_m0-m";
export var messageInputForm = "_m0-o";
export var messageInputFormInternal = "_m0-p";
export var options = "_m0-q";
export var publicMessageCustomer = "_m0-s";
export var publicMessageMerchant = "_m0-r";
export var removeImageButton = "_m0-d";
export var replyButtons = "_m0-t";
export var showSignatureButton = "_m0-u";
export var spinner = "_m0-v";
export var verticalButtonDivider = "_m0-4";
export var visibilitySelector = "_m0-w";
export var warning = "_m0-x";
export var wrappingText = "_m0-z";
export var writingInternalNoteTopBorder = "_m0-10";